<template>
    <div>
        <LaFlashMessages />
        <router-view />
    </div>
</template>

<script>
import LaFlashMessages from "@/components/FlashMessages";
import { getItem, setItem } from "@/store/persistantStorage";
const { version: appVersion } = require("/package.json");

import variant from "@/helpers/variant";

export default {
    name: "App",
    components: { LaFlashMessages },
    setup() {
        localStorage.setItem("adminversion", appVersion);

        if (variant === "performax") {
            // Strip any leftover dark/light classes from LTBA usage
            document.body.classList.remove("dark", "light");
            document.body.classList.add("variant-performax");
            setItem("theme", "light");
        } else {
            const theme = getItem("theme") || "dark";
            setItem("theme", theme);
            document.body.classList.add(theme);
        }

        return {};
    },
};
</script>

<style lang="scss">
@import "~@/styles/main.scss";
</style>
